"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeReputationVoteValue = decodeReputationVoteValue;
exports.decodeReputationVoteSource = decodeReputationVoteSource;
exports.mapReputationVoteModified = mapReputationVoteModified;
const mapper_1 = require("./mapper");
function decodeReputationVoteValue(raw) {
    const n = typeof raw === 'number' ? raw : Number(raw) || 0;
    return {
        raw: n,
        isDown: (n & 1) === 0,
        isUp: (n & 1) !== 0,
        isDenied: (n & 2) !== 0,
    };
}
/** Источник голоса по topicId/postId (Android ReputationParser). */
function decodeReputationVoteSource(topicId, postId) {
    const topic = Number(topicId) || 0;
    const post = Number(postId) || 0;
    if (topic === 0 && post === 0)
        return 'profile';
    if (post < 0)
        return 'site_comment';
    return 'forum_post';
}
function mapReputationVoteModified(parts) {
    const atRaw = parts[0];
    if (atRaw == null || atRaw === 0 || atRaw === '')
        return undefined;
    const userId = Number(parts[1]) || 0;
    const userName = typeof parts[2] === 'string' ? parts[2] : '';
    const at = mapper_1.PdaMapper.safeIsoDate(atRaw);
    if (!at || !userId)
        return undefined;
    return { at, userId, userName };
}
